export class InvalidQuestionTypeError extends Error {
    constructor(type: string) {
        super(`${type} is not a valid question type`);
    }
}
